// extracted by mini-css-extract-plugin
module.exports = {"multiselect":"ChoosePartyModal_multiselect_3BGzj","add-debtor":"ChoosePartyModal_add-debtor_3bmzY","addDebtor":"ChoosePartyModal_add-debtor_3bmzY"};